import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const BroomIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path
      fillRule="evenodd"
      d="m21.45 21.45-1.35-5.175h.225c.3 0 .525-.075.675-.3.15-.15.3-.45.3-.675v-2.25c0-.825-.3-1.575-.9-2.1-.525-.525-1.35-.9-2.1-.9h-5.4V2.475c.075-.525-.375-.975-.9-.975a.993.993 0 0 0-.975.975v7.575h-5.4c-.825 0-1.575.3-2.1.9-.525.6-.9 1.35-.9 2.1v2.25c0 .525.45.975.975.975l-1.725 5.1c-.075.3-.075.675.15.9.225.3.525.45.825.45h17.7c.3 0 .6-.15.825-.375.075-.225.15-.6.075-.9Zm-16.8-8.4c0-.3.075-.525.3-.675.15-.15.45-.3.675-.3h12.75c.3 0 .525.075.675.3.15.15.3.45.3.675v1.275H4.65V13.05Zm12.075 7.65v-.15l-.525-2.025c-.15-.525-.675-.825-1.2-.75-.525.15-.825.675-.75 1.2l.45 1.725H4.2l1.5-4.35h12.375L19.2 20.7h-2.475Z"
      clipRule="evenodd"
    />
  </Icon>
));
export default BroomIcon;
